import {FC, useState} from 'react'
import {CoursePatientInfo} from '../../../../Adaptor/TUBSIS/controllers/Courses/models/getCoursePatientInfoByCourseIdModels'
import {KTIcon, toAbsoluteUrl} from '../../../../_metronic/helpers'
import {TablesWidget9} from '../../../../_metronic/partials/widgets'
type Props = {
  patient: CoursePatientInfo
  onClick?: () => void
}
const PatientCard: React.FC<Props> = ({patient, onClick}) => {
  let Percent = patient.completionPercent
    ? patient.completionPercent
    : 0 /*TotalContentCount !== 0 ? (100 * DoneContentCount) / TotalContentCount : 0*/

  let ChartColor =
    Percent < 26 ? 'danger' : Percent < 51 ? 'warning' : Percent < 91 ? 'success' : 'primary'
  ////debugger
  return (
    <>
      <div className='d-flex flex-stack py-4 w-full'>
        <div className='d-flex align-items-center'>
          <div className='symbol symbol-45px symbol-circle'>
            {false ? (
              <img alt='Pic' src={toAbsoluteUrl('/media/avatars/300-1.jpg')} />
            ) : (
              <span
                className={`symbol-label  bg-light-${ChartColor} text-${ChartColor} fs-6 fw-bolder`}
              >
                {patient.name[0]}
              </span>
            )}
          </div>

          <div className='ms-5'>
            {onClick ? (
              <a
                className='fs-5 fw-bolder text-gray-900 text-hover-primary cursor-pointer  mb-2'
                onClick={onClick}
              >
                {`${patient.name} ${patient.surname}`}
              </a>
            ) : (
              <div className='fs-5 fw-bolder text-gray-900 cursor-pointer mb-2'>
                {`${patient.name} ${patient.surname}`}
              </div>
            )}
            <div className='fw-bold text-gray-400'> {patient.mail}</div>
          </div>
        </div>

        {onClick && (
          <div className='d-flex flex-column align-items-end ms-2'>
            {/* <div
            className={'bg-' + ChartColor + ' rounded'}
            role='progressbar'
            style={{width: Percent + '%'}}
          ></div> */}

            <div className='d-flex flex-column mb-2 ms-15'>
              <span className='text-muted me-2 fs-7 fw-semibold'>
                {parseInt(Percent.toString()) + '%'}
              </span>
            </div>
            <div className='progress h-6px w-100'>
              <div
                className={`progress-bar bg-${ChartColor}`}
                role='progressbar'
                style={{width: Percent + '%'}}
              ></div>
            </div>
          </div>
        )}
      </div>

      <div className='separator separator-dashed d-none'></div>
    </>
  )
}
export {PatientCard}
